import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/date.default.js
// module id = 1265
// module chunks = 0